import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 lg:py-24 text-center" data-testid="not-found-page">
      <Seo path="/404" title="Page Not Found" description="The page you're looking for may have moved, changed, or no longer exists." noindex />
      <img
        src="/404.jpg"
        alt="Ravemora Global — 404 page not found"
        className="mx-auto w-full max-w-2xl h-auto"
        data-testid="not-found-image"
      />
      <p className="mt-8 text-lg text-navy/70 leading-relaxed max-w-xl mx-auto" data-testid="not-found-message">
        The page you're looking for may have moved, changed, or no longer exists.
      </p>
      <Link to="/" className="btn-primary mt-10 inline-flex items-center gap-2" data-testid="not-found-home">
        <ArrowRight size={14}/> Back to Home
      </Link>
    </div>
  );
}
